import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getInternalAccountList(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.MANAGER_INTERNAL_ACCOUNT}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async createInternalAccount(payload) {
    await axiosClient.post(ENDPOINT.MANAGER_INTERNAL_ACCOUNT, payload);
  },

  async detailInternalAccount(payload) {
    const path = `${ENDPOINT.MANAGER_INTERNAL_ACCOUNT}/${payload}`;
    const response = await axiosClient.get(path);

    return response.data;
  },

  async updateInternalAccount(payload) {
    const { id, ...data } = payload;
    const path = `${ENDPOINT.MANAGER_INTERNAL_ACCOUNT}/${id}`;
    await axiosClient.put(path, data);
  },

  async deleteInternalAccount(payload) {
    const path = `${ENDPOINT.MANAGER_INTERNAL_ACCOUNT}/${payload}`;
    await axiosClient.delete(path);
  },

};
